import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import API_BASE_URL from "../../config/api";
import './register.css';
import quiz from '../../assets/compressed/quiz.jpg';
import rulebook from '../../assets/Robocor_Rulebook_2025.pdf';
import backgroundImg from '../../assets/demo.jpg';
import Loading from '../../components/Loading.js';

export const eventRules = {
  "Binary Runes": { min: 1, max: 2 },
  "Arduino Alchemy": { min: 1, max: 3 },
  "Hex Track": { min: 1, max: 4 },
  "Runic Maze": { min: 1, max: 4 },
  "Project Nexus": { min: 2, max: 4 },
  "Construct Clash": { min: 1, max: 4 },
  "Arcane Quiz":{min:1,max:1},
  "Zaun Race":{min:1,max:4},
  "BGMI Rush":{min:2,max:4},
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;
//const usnRegex = /^[1-9][A-Z]{2}\d{2}[A-Z]{2}\d{3}$/i;

const Register = () => {
  const formViewRef = useRef(null);
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);
  const [clicked, setClicked] = useState(false);
  
  const [selectedEvent] = useState("Arcane Quiz"); // default for demo
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [registrationClosed] = useState(false); // toggle manually if needed
  const [submitted, setSubmitted] = useState(false);
  
  const [validForm, setValidForm] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  

  
  

  useEffect(() => {
    const { min } = eventRules[selectedEvent];
    setFormData(Array.from({ length: min }, () => ({ name: "", email: "", usn: "", phone: "" })));
  }, [selectedEvent]);

  const scrollFormViewToTop = (behavior = "auto") => {
    window.scrollTo({ top: 0, behavior });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    formViewRef.current?.scrollIntoView({ block: "start", behavior });
  };

  useLayoutEffect(() => {
    if (!showRegistrationForm) return;

    scrollFormViewToTop("auto");

    const rafId = window.requestAnimationFrame(() => {
      scrollFormViewToTop("auto");
    });

    const timeoutId = window.setTimeout(() => {
      scrollFormViewToTop("smooth");
    }, 80);

    return () => {
      window.cancelAnimationFrame(rafId);
      window.clearTimeout(timeoutId);
    };
  }, [showRegistrationForm]);

  useEffect(() => {
          const isValid = formData.every(
            (p) =>
              p.name.trim() !== "" &&
              emailRegex.test(p.email) &&
              phoneRegex.test(p.phone) 
          );
          setValidForm(isValid);
        }, [formData]);

  const handleChange = (index, e) => {
    const newFormData = [...formData];
    newFormData[index][e.target.name] = e.target.value;
    setFormData(newFormData);
  };

  const handleAddMember = () => {
    const { max } = eventRules[selectedEvent];
    if (formData.length < max) {
      setFormData([...formData, { name: "", email: "", usn: "", phone: "" }]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setLoading(true);
    setError(null);
    setSuccess(null);

    const hasInvalidData = formData.some(
      (p) =>
        !p.name.trim() ||
        !emailRegex.test(p.email) ||
        !p.usn.trim() ||
        !phoneRegex.test(p.phone)
    );

    if (hasInvalidData) {
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/api/register`, {
        event: selectedEvent,
        members: formData,
      }, { withCredentials: true });

      setSuccess("Successfully registered!");
      setClicked(true); // Proceed to checkout
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleProceedClick = () => {
    scrollFormViewToTop("auto");
    setShowRegistrationForm(true);
  };

   if (loading) {
  return <Loading />;
}

  if (registrationClosed) {
    return (
      <div className="cyber-bg d-flex flex-column justify-content-center align-items-center vh-100 text-center text-light">
        <h1 className="register-page-title">Online registrations closed</h1>
        <p className="mt-3">On-spot Registrations at Media Centre</p>
      </div>
    );
  }

  // Payment iframe page
  if (clicked) {
    return (
      <>
      {!iframeLoaded && <Loading />}
      <iframe title="ticket-frame" 
        onLoad={() => setIframeLoaded(true)}
        width="100%"
        height="100%"
        style={{
          display: iframeLoaded ? 'block' : 'none',
          border: 'none',
          minHeight: "100vh"
        }}
           src="https://www.yepdesk.com/embed/buy-tickets/69cd584b46e0fb0001287228/private/93drj013nd"
        /> 
      </>
    );
  }

  // Registration form page
  if (showRegistrationForm) {
    return (
      <div ref={formViewRef} className="cyber-bg cyber-content-wrapper">
              <style>
                {`
                  .cyber-bg::before {
                    background-image: url(${backgroundImg});
                  }
            
                  @media (max-width: 768px) {
                    .arc-character-img {
                      max-width: 100%;
                      height: auto;
                      margin-bottom: 1rem;
                    }
                    .form-container {
                      width: 100%;
                      padding: 1rem;
                    }
                  }
            
                  @media (min-width: 768px) {
                    .arc-character-img {
                      max-width: 300px;
                    }
                    .form-container {
                      padding: 1rem;
                    }
                  }
                `}
              </style>
            
              <div className="cyber-content">
                <div className="cyber-card">
                  {/* Flex layout switches based on screen width */}
                  <div className="d-flex flex-column flex-md-row justify-content-center align-items-center">
                    {/* Image section */}
                    <div className="text-center" style={{ flex: 1, padding: '1rem' }}>
                      <img
              src={quiz}
              alt="Arcane Quiz"
              className="arc-character-img event-image cyber-img"
            />
            
                    </div>
            
                    {/* Form section */}
                    <div className="form-container" style={{ flex: 1 }}>
                      <h1 className="mt-4">Arcane Quiz</h1>
                      <p className="arc-quote mt-4">
                        "Test your knowledge, challenge your mind, and emerge as the ultimate quiz champion!"
                      </p>
            
                      <div className="arc-form-card mt-4">
                        {error && <Alert variant="danger">{error}</Alert>}
                        {success && <Alert variant="success">{success}</Alert>}
            
                        <Form noValidate onSubmit={handleSubmit}>
                          {formData.map((participant, index) => (
                            <div
                              key={index}
                              className="mb-3 p-3 border rounded text-light bg-dark"
                            >
                              <h5 className="arc-neon-text">Participant {index + 1}</h5>
                              <Form.Group className="mb-2">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                  className="arc-input"
                                  type="text"
                                  name="name"
                                  value={participant.name}
                                  onChange={(e) => handleChange(index, e)}
                                  isInvalid={submitted && !participant.name.trim()}
                                  required
                                />
                                <Form.Control.Feedback type="invalid">
                                  Name is required.
                                </Form.Control.Feedback>
                              </Form.Group>
                              <Form.Group className="mb-2">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                  className="arc-input"
                                  type="email"
                                  name="email"
                                  value={participant.email}
                                  onChange={(e) => handleChange(index, e)}
                                  isInvalid={(submitted || participant.email) && !emailRegex.test(participant.email)}
                          required
                                />
                                <Form.Control.Feedback type="invalid">
                                  Enter a valid email address.
                                </Form.Control.Feedback>
                              </Form.Group>
                              <Form.Group className="mb-2">
                                <Form.Label>USN</Form.Label>
                                <Form.Control
                                  className="arc-input"
                                  type="text"
                                  name="usn"
                                  value={participant.usn}
                                  onChange={(e) => handleChange(index, e)}
                                  isInvalid={submitted && !participant.usn.trim()}
                                  required
                                />
                                <Form.Control.Feedback type="invalid">
                                  USN is required.
                                </Form.Control.Feedback>
                              </Form.Group>
                              <Form.Group className="mb-2">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                  className="arc-input"
                                  type="text"
                                  name="phone"
                                  value={participant.phone}
                                  onChange={(e) => handleChange(index, e)}
                                  isInvalid={(submitted || participant.phone) && !phoneRegex.test(participant.phone)}
                                  required
                                />
                                <Form.Control.Feedback type="invalid">
                                  Enter a valid 10-digit phone number.
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                          ))}
            
                          {formData.length < eventRules[selectedEvent].max && (
                            <Button
                              className="cyber-button mb-3 w-100"
                              onClick={handleAddMember}
                            >
                              Add Member
                            </Button>
                          )}
            
                          <Button
                            type="submit"
                            className="cyber-button mb-3 w-100"
                            disabled={loading || !validForm}
                          >
                            {loading ? <Spinner animation="border" size="sm" /> : 'Submit & Pay'}
                          </Button>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
  

  // Event details page
  return (
   <div className="container-fluid cyber-bg"
    style={{
    position: 'relative',
     }}>
     {/* Inline style for background image overlay */}
    <style>
    {`
      .cyber-bg::before {
       background-image: url(${backgroundImg});  }
    `}
    </style>
    <h1 className="register-page-title">Register</h1>
             
    <div className="cyber-content">
       <div className="cyber-card row">
          <div className="col-md-6 text-center mb-3 mb-md-0">
              <img src={quiz} className="event-image" alt="bytewars" />
                  </div>
             
                  <div className="col-md-6">
                     <h2 className="mt-4">{selectedEvent}</h2>
                     <p className="cyber-head" ><strong >Timing:</strong> 12:45 PM</p>
                     <p className="cyber-head"><strong >Venue:</strong> Online</p>
                     <p className="cyber-head"><strong >Team Size:</strong> {eventRules[selectedEvent].min} - {eventRules[selectedEvent].max}</p>
                     <p className="cyber-head"><strong >Fee:</strong> ₹50</p>
       <div className="flex gap-4 cyber-head ">
  <p>1st Prize : 1 K</p>
  <p>2nd Prize : 500 </p>
</div>
             
  <h4 className="mt-4">Event Rules:</h4>
  <div className="content">
    <p>- This event consists of 2 rounds.</p>
    <p>- The quiz will be conducted in online mode (using Slido platform).</p>
    <p>- The number of questions will be 40 in the first round and 20 in the second round.</p>
    <p>- Quiz round 1 start timing is 12:45 pm.</p>
    <p>- Round 2 timings will be announced later for those who qualify for round 1.</p>
    <p>- Quiz timings will be very strict; if you miss the slot, you will not get another chance.</p>
    <p>- The top 30 will be selected for round 2.</p>
    <p>- Winners are determined based on the maximum score.</p>
    <p>- If scores are tied for both participants, the winner will be declared based on timings.</p>
    <p>- The judge's decision will be final.</p>
                     </div>
             
                     <div className="container-fluid mt-4">
               <div className="container px-3 py-4">
               <div className="container text-center mt-4">
               <div className="container mt-4">
               <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-3 ps-sm-4">
                 <a href={rulebook} download className="cyber-button">
                   RULE BOOK
                 </a>
                 <button className="cyber-button" onClick={handleProceedClick}>
                   REGISTER
                 </button>
               </div>
             </div>
             
             </div>
             
             </div>
             
             </div>
             
             
                   </div>
                 </div>
               </div>
             </div>
  );
};

export default Register;

